import { generateUUID } from 'shared/helpers/utils/generate-uuid';
import { TableFilterFieldType } from 'shared/UI/UIKit/TableFilter';
import type { TableFilterField } from 'shared/UI/UIKit/TableFilter';
import styles from '../ui/styles.module.scss';

const selectFieldClassNames = {
  dropdownMatchSelectWidth: false,
  dropdownClassName: styles.selectDropdown,
};

export const scheduleFilterFields: TableFilterField[] = [
  {
    key: generateUUID(),
    name: 'teacherId',
    label: 'Преподаватель',
    type: TableFilterFieldType.SELECT,
    placeholder: 'Преподаватель',
    ...selectFieldClassNames,
  },
  {
    key: generateUUID(),
    name: 'subjectIds',
    label: 'Предметы',
    type: TableFilterFieldType.MULTI_SELECT,
    placeholder: 'Предметы',
    ...selectFieldClassNames,
  },
  {
    key: generateUUID(),
    name: 'roomIds',
    label: 'Кабинеты',
    type: TableFilterFieldType.MULTI_SELECT,
    placeholder: 'Кабинеты',
    ...selectFieldClassNames,
  },
  {
    key: generateUUID(),
    name: 'educationalClassIds',
    label: 'Классы',
    type: TableFilterFieldType.MULTI_SELECT,
    placeholder: 'Классы',
    ...selectFieldClassNames,
  },
];
